
import { Modal, Box, Autocomplete, TextField, InputAdornment, Button as MuiButton, FormControl, FormGroup, Switch } from "@mui/material";
import { notify } from "../../utils/notify";
import { useState, useEffect } from "react";
import { fetchFreshFacebookAdsetsByCampaign } from "../../services/getAllCampaigns";
import createDuplicateAdset from "../../services/createDuplicateAdset";
import getTimeZoneDeltaUTC from "../../services/adsets/getTimeZone"
import { Loader } from "@components/Loader"

const DuplicateAdsetModal = ({
  open,
  onClose,
  adsets = [],
  loadingAdsets = false,
  selectedCampaign,
  refreshAdsets = null,
  adsetsByCampaign = [],
  adAccountId = null,
}) => {
  const [selectedAdSetForDuplicate, setSelectedAdSetForDuplicate] = useState(null);
  // ...existing code...
  const [duplicateAdSetName, setDuplicateAdSetName] = useState("");
  const [adSetBudget, setAdSetBudget] = useState("");
  const [isAdSetDuplicating, setIsAdSetDuplicating] = useState(false);
  const [adStatus, setAdStatus] = useState(false);
  const [campaignAdsets, setCampaignAdsets] = useState([]);
  const [loadingCampaignAdsets, setLoadingCampaignAdsets] = useState(false);
  // Advanced settings state
  const [advancedSettingsEnabled, setAdvancedSettingsEnabled] = useState(false);
  const [startDateTime, setStartDateTime] = useState("");
  const [endDateTime, setEndDateTime] = useState("");
  const [timeZoneDelta, setTimeZoneDelta] = useState(null);

  // Fetch adsets for the given campaignId when modal opens
  // useEffect(() => {
  //   const fetchAdsets = async () => {
  //     if (!open || !selectedCampaign.campaignId) return;
  //     setLoadingCampaignAdsets(true);
  //     try {
  //       const userId = localStorage.getItem("userId");
  //       const adAccountId = localStorage.getItem("adAccountId");
  //       const response = await fetchFreshFacebookAdsetsByCampaign({
  //         user_id: userId,
  //         campaign_id: selectedCampaign.campaignId,
  //         ad_account_id: adAccountId,
  //       });
  //       setCampaignAdsets(response?.data || []);
  //     } catch {
  //       setCampaignAdsets([]);
  //     }
  //     setLoadingCampaignAdsets(false);
  //   };
  //   fetchAdsets();
  // }, [open, selectedCampaign]);

  useEffect(() => {
    const fetchTimeZoneDelta = async () => {
      if (!adAccountId) return;
      const response = await getTimeZoneDeltaUTC(adAccountId);
      if (response) {
        setTimeZoneDelta(response.timezone_offset_hours_utc);
        console.log("TimeZone delta:", response.timezone_offset_hours_utc);
      }

    };
    fetchTimeZoneDelta();
  }, [adAccountId]);

  useEffect(() => {
    if (adsetsByCampaign) {
      setCampaignAdsets(adsetsByCampaign);
    }
  }, [open, adsetsByCampaign]);

  // Merge campaign adsets first, then others, with a separator
  const getAdSetId = (a) => String(a.id ?? a.adsetId ?? "");
  const campaignAdSetIds = new Set(campaignAdsets.map(getAdSetId));
  const filteredOtherAdSets = adsets.filter(a => !campaignAdSetIds.has(getAdSetId(a)));
  const mergedAdsets = [
    ...campaignAdsets,
    ...(filteredOtherAdSets.length > 0 ? [{ type: "separator", label: "Other Ad Sets" }] : []),
    ...filteredOtherAdSets
  ];

  const handleAdSetForDuplicateSelection = (event, newValue) => {
    setSelectedAdSetForDuplicate(newValue);
    if (newValue) {
      // console.log("Selected AdSet for duplication:", newValue);
      setDuplicateAdSetName(`${newValue.name} - Copy`);
      setAdSetBudget("");
      if (newValue?.dailyBudget) {
        // console.log("Setting budget from selected adset:", newValue.dailyBudget);
        setAdSetBudget(String(Number(newValue.dailyBudget) / 100));
      }
    } else {
      setDuplicateAdSetName("");
      setAdSetBudget("");
    }
  };

  // Handler for adset name change
  const handleDuplicateAdSetNameChange = (event) => {
    setDuplicateAdSetName(event.target.value);
  };

  // Handler for budget change
  const handleAdSetBudgetChange = (event) => {
    setAdSetBudget(event.target.value);
  };

  // Handler for saving duplicate adset
  const handleSaveAdSetDuplicate = async () => {
    let isValidBudget = true;
    // Only validate budget for ABO
    if (selectedCampaign?.budgetType === "ABO") {
      const val = adSetBudget?.trim();
      if (!val) isValidBudget = false;
      const num = Number(val);
      if (isNaN(num) || num <= 0) isValidBudget = false;
    }
    if (
      !selectedAdSetForDuplicate ||
      !duplicateAdSetName?.trim() ||
      (selectedCampaign?.budgetType === "ABO" && !isValidBudget)
    ) {
      notify("Please fill in all required fields", "error");
      return;
    }
    const adAccountId = localStorage.getItem("adAccountId");
    // Manually assign each key for payload
    const payload = {
      user_id: selectedAdSetForDuplicate?.userId,
      ad_account_id: adAccountId,
      reference_adset_id: selectedAdSetForDuplicate?.adsetId,
      status: adStatus === true ? "ACTIVE" : "PAUSED",
      campaign_id: selectedCampaign?.campaignId,
      name: duplicateAdSetName,
      // Advanced settings - format datetime with timezone
      start_time: advancedSettingsEnabled && startDateTime ? (() => {
        const date = new Date(startDateTime);
        const offset = timeZoneDelta !== null ? timeZoneDelta * 60 : date.getTimezoneOffset();
        const sign = offset > 0 ? '+' : '-';
        const hours = Math.floor(Math.abs(offset) / 60).toString().padStart(2, '0');
        const minutes = (Math.abs(offset) % 60).toString().padStart(2, '0');
        const final = startDateTime + `${sign}${hours}:${minutes}`
        return final;
        // return date.toISOString().replace('Z', `${sign}${hours}:${minutes}`);
        // return date.toISOString();
      })() : null,
      end_time: advancedSettingsEnabled && endDateTime ? (() => {
        const date = new Date(endDateTime);
        const offset = timeZoneDelta !== null ? timeZoneDelta * 60 : date.getTimezoneOffset();
        const sign = offset > 0 ? '+' : '-';
        const hours = Math.floor(Math.abs(offset) / 60).toString().padStart(2, '0');
        const minutes = (Math.abs(offset) % 60).toString().padStart(2, '0');
        const final = endDateTime + `${sign}${hours}:${minutes}`
        return final;
        // return date.toISOString().replace('Z', `${sign}${hours}:${minutes}`);
        // return date.toISOString();
      })() : null,
    };
    if (selectedCampaign?.budgetType === "ABO") {
      payload.daily_budget = Number(adSetBudget) * 100;
    }
    try {
      setIsAdSetDuplicating(true);
      await createDuplicateAdset(payload);
      // notify("Ad Set duplicated successfully!", "success");
      if (typeof refreshAdsets === "function") {
        await refreshAdsets();
      }
      resetModalState();
      onClose("success");
    } catch {
      // notify("Failed to duplicate ad set.", "error");
      onClose("error");
    } finally {
      setIsAdSetDuplicating(false);
    }
  };

  // Reset modal state
  const resetModalState = () => {
    setSelectedAdSetForDuplicate(null);
    setDuplicateAdSetName("");
    setAdSetBudget("");
    setAdStatus(false);
    setAdvancedSettingsEnabled(false);
    setStartDateTime("");
    setEndDateTime("");
  };

  // Reset state when modal closes
  const handleClose = () => {
    resetModalState();
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="adset-modal-title"
      aria-describedby="adset-modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 613,
          bgcolor: 'background.paper',
          borderRadius: 3,
          boxShadow: 24,
          p: 0,
          padding: '24px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
        }}
      >
        <h2
          id="adset-modal-title"
          className="font-inter font-medium not-italic text-[22px] leading-[1.2] tracking-[-0.01em] mb-3 text-left w-full"
        >
          Duplicate Ad Set
        </h2>
        <div
          className="font-inter font-normal not-italic text-[16px] leading-[1.4] text-gray-500 text-left w-full mt-0"
        >
          Copy settings from an existing ad set. Ads won&apos;t be included.
        </div>
        <div
          className="mt-6 mb-2 font-inter font-medium not-italic text-[14px] leading-[1.2] tracking-[0] text-[#1F2937] text-left w-full"
        >
          Select ad set you want to copy from
        </div>
        <div style={{ width: 565 }}>
          <Autocomplete
            options={mergedAdsets}
            loading={loadingAdsets || loadingCampaignAdsets}
            value={selectedAdSetForDuplicate}
            onChange={(event, newValue) => {
              // Prevent selecting the separator
              if (newValue && newValue.type === "separator") return;
              handleAdSetForDuplicateSelection(event, newValue);
            }}
            getOptionLabel={(option) => option.type === "separator" ? option.label : option.name || ""}
            isOptionEqualToValue={(option, value) => option?.adsetId === value?.adsetId}
            popupIcon={<img src="/chevronDown.svg" alt="dropdown" style={{ width: 20, height: 20 }} />}
            sx={{
              width: 565,
              height: 46,
              borderRadius: '8px',
              borderColor: '#D7D7D7',
              justifyContent: 'space-between',
              boxShadow: '0px 1px 2px 0px #0000000A',
              opacity: 1,
              '& .MuiOutlinedInput-root': {
                borderRadius: '8px',
                borderColor: '#D7D7D7',
                minHeight: 46,
                paddingTop: '12px',
                paddingBottom: '12px',
                boxShadow: '0px 1px 2px 0px #0000000A',
                backgroundColor: '#fff',
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#D7D7D7',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#D7D7D7',
                  borderWidth: '1px'
                },
                '&.Mui-focused': {
                  outline: 'none',
                },
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#D7D7D7',
              },
            }}
            slotProps={{
              paper: {
                sx: {
                  mt: '8px',
                  border: '1px solid #D7D7D7',
                  boxSizing: 'border-box',
                  padding: '8px',
                  borderRadius: '8px',
                  width: 565,
                  overflowX: 'hidden',
                },
              },
            }}
            ListboxProps={{
              style: {
                padding: 0,
                overflowX: 'hidden',
              },
            }}
            renderOption={(props, option, { selected }) => {
              if (option.type === "separator") {
                return (
                  <li key={option.label} style={{
                    padding: '8px 0 8px 12px',
                    textAlign: 'left',
                    fontWeight: 600,
                    color: '#6B7280',
                    background: '#F3F4F6',
                    borderRadius: '6px',
                    fontSize: '13px',
                    margin: '4px 0',
                  }}>
                    {option.label}
                  </li>
                );
              }
              // Use a unique key for each option
              const { key, ...rest } = props;
              const uniqueKey = option.adsetId || option.id || key;
              return (
                <li
                  key={uniqueKey}
                  {...rest}
                  className={`w-full rounded-lg p-3 gap-1 opacity-100 flex items-center box-border ${selected ? 'bg-gray-100' : ''}`}
                  style={{ minHeight: 50, height: 'auto', whiteSpace: 'normal', alignItems: 'flex-start', marginBottom: '4px' }}
                  onMouseEnter={(e) => {
                    e.currentTarget.classList.add('bg-gray-100');
                  }}
                  onMouseLeave={(e) => {
                    if (!selected) e.currentTarget.classList.remove('bg-gray-100');
                  }}
                >
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span
                      style={{
                        fontFamily: 'Inter, sans-serif',
                        fontWeight: 500,
                        fontStyle: 'normal',
                        fontSize: 16,
                        lineHeight: '140%',
                        textAlign: 'left',
                        width: '100%',
                        display: 'block',
                      }}
                    >
                      {option.name || ''}
                    </span>
                    {option.campaignName && (
                      <span
                        style={{
                          marginTop: 4,
                          marginBottom: 4,
                          fontFamily: 'Inter, sans-serif',
                          fontWeight: 400,
                          fontStyle: 'normal',
                          fontSize: 16,
                          lineHeight: '100%',
                          color: '#6B7280',
                        }}
                      >
                        {option.campaignName}
                      </span>
                    )}
                  </div>
                </li>
              );
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Reference Ad Set"
                variant="outlined"
                required
                size="small"
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <InputAdornment position="start" sx={{ marginRight: 0 }}>
                      <span className="flex items-center pl-3 pr-1">
                        <img src="/pointer.svg" alt="pointer" className="w-5 h-5" />
                      </span>
                    </InputAdornment>
                  ),
                  style: { paddingLeft: 0, textAlign: 'left', outline: 'none' },
                }}
                inputProps={{
                  ...params.inputProps,
                  style: { ...params.inputProps?.style, paddingLeft: 0, textAlign: 'left', outline: 'none' },
                }}
              />
            )}
          />
        </div>
        {selectedAdSetForDuplicate && (
          <FormControl component="fieldset" style={{ width: '100%' }}>
            <FormGroup>
              <div style={{ marginTop: 24, width: '100%' }}>
                <div className="font-inter font-medium not-italic text-[14px] leading-[1.2] tracking-[0] text-[#1F2937] mb-2">
                  Name of the Ad Set
                </div>
                <TextField
                  value={duplicateAdSetName}
                  onChange={handleDuplicateAdSetNameChange}
                  placeholder="Enter ad set name"
                  variant="outlined"
                  fullWidth={false}
                  size="medium"
                  InputProps={{
                    className: "rounded-lg font-inter text-[15px] bg-white w-[565px] h-[46px] gap-[10px] opacity-100 p-3 box-border",
                  }}
                  sx={{
                    marginBottom: 0,
                    width: 565,
                    height: 46,
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '8px',
                      height: 46,
                      boxShadow: '0px 1px 2px 0px #0000000A',
                      border: '1px solid #D7D7D7',
                      padding: '0 12px',
                      background: '#fff',
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: 'none',
                    },
                    '& .MuiOutlinedInput-input': {
                      padding: 0,
                      height: 46,
                      display: 'flex',
                      alignItems: 'center',
                    },
                  }}
                  required
                  error={!duplicateAdSetName?.trim()}
                  helperText={!duplicateAdSetName?.trim() ? "Ad set name is required" : ""}
                />
              </div>
              {/* Show Ad Set Budget field only if ad set name is filled and budgetType is ABO */}
              {duplicateAdSetName && selectedCampaign?.budgetType === "ABO" && (
                <div className="w-full mt-6">
                  <div className="font-inter font-medium not-italic text-[14px] leading-[1.2] tracking-[0] text-[#1F2937] mb-2">
                    Ad Set Budget
                  </div>
                  <TextField
                    value={adSetBudget}
                    onChange={handleAdSetBudgetChange}
                    placeholder="00.0"
                    variant="outlined"
                    fullWidth={false}
                    size="medium"
                    type="number"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start" sx={{ marginRight: 0 }}>
                          <img src="/dollar.svg" alt="$" style={{ width: 20, height: 20 }} />
                        </InputAdornment>
                      ),
                      className: "rounded-lg font-inter text-[15px] bg-white w-[565px] h-[46px] gap-[10px] opacity-100 p-3 box-border",
                      inputProps: { min: 0 },
                    }}
                    sx={{
                      marginBottom: 0,
                      width: 565,
                      height: 46,
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '8px',
                        height: 46,
                        boxShadow: '0px 1px 2px 0px #0000000A',
                        border: '1px solid #D7D7D7',
                        padding: '0 12px',
                        background: '#fff',
                      },
                      '& .MuiOutlinedInput-notchedOutline': {
                        border: 'none',
                      },
                      '& .MuiOutlinedInput-input': {
                        padding: 0,
                        height: 46,
                        display: 'flex',
                        alignItems: 'center',
                      },
                    }}
                    required
                    error={selectedCampaign?.budgetType === "ABO" && (!adSetBudget?.trim() || isNaN(Number(adSetBudget)) || Number(adSetBudget) <= 0)}
                  />
                </div>
              )}
              {/* Advanced Settings Switch and Fields */}
              <hr style={{ width: '100%', border: 'none', borderBottom: '1px solid #E5E7EB', margin: '20px 0' }} />
              <div className="mt-0 w-[565px] h-[46px] flex items-center justify-between bg-[#F3F4F6] rounded-lg px-4 py-3 gap-2">
                <span className="flex items-center gap-2">
                  <img src="/settings.svg" alt="settings" className="w-5 h-5" />
                  <span className="font-inter font-medium text-base leading-[140%] tracking-[0%] text-center text-gray-800">
                    Edit Advanced Settings
                  </span>
                </span>
                <Switch
                  checked={advancedSettingsEnabled}
                  onChange={(_, checked) => setAdvancedSettingsEnabled(checked)}
                  color="primary"
                  inputProps={{ 'aria-label': 'Edit Advanced Settings' }}
                  sx={{
                    '& .MuiSwitch-switchBase.Mui-checked': {
                      color: '#6E65ED',
                    },
                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                      backgroundColor: '#6E65ED',
                    },
                  }}
                />
              </div>
              {advancedSettingsEnabled && (
                <div className="w-full mt-4">
                  <div className="mt-6 w-[565px] flex gap-4">
                    <div className="w-[270px] flex flex-col gap-2">
                      <span className="font-inter font-medium text-sm leading-[120%] text-gray-800 mb-1">
                        Start Date & Time
                      </span>
                      <input
                        type="datetime-local"
                        value={startDateTime || ''}
                        onChange={e => {
                          setStartDateTime(e.target.value);
                          // set end date to the next day midnight
                          if (e.target.value) {
                            const nextDay = new Date(e.target.value);
                            nextDay.setDate(nextDay.getDate() + 1);
                            nextDay.setHours(0, 0, 0, 0);

                            // Format the date to match datetime-local input format
                            const year = nextDay.getFullYear();
                            const month = String(nextDay.getMonth() + 1).padStart(2, '0');
                            const day = String(nextDay.getDate()).padStart(2, '0');
                            setEndDateTime(`${year}-${month}-${day}T23:59`);
                          }
                        }}
                        className={`w-full h-[46px] rounded-lg border border-[#E4E4E7] px-3 text-[15px] font-inter bg-white opacity-100 ${!startDateTime ? 'text-gray-500' : 'text-gray-800'}`}
                        min={(() => {
                          const date = new Date();
                          const year = date.getFullYear();
                          const month = String(date.getMonth() + 1).padStart(2, '0');
                          const day = String(date.getDate()).padStart(2, '0');
                          const hours = String(date.getHours()).padStart(2, '0');
                          const minutes = String(date.getMinutes()).padStart(2, '0');
                          return `${year}-${month}-${day}T${hours}:${minutes}`;
                        })()}
                        step="60"
                      />
                    </div>
                    <div className="w-[270px] flex flex-col gap-2">
                      <span className="font-inter font-medium text-sm leading-[120%] tracking-[0%] text-gray-800 mb-1">
                        End Date & Time
                      </span>
                      <input
                        type="datetime-local"
                        value={endDateTime || ''}
                        onChange={e => setEndDateTime(e.target.value)}
                        className={`w-full h-[46px] rounded-lg border border-[#E4E4E7] px-3 text-[15px] font-inter bg-white ${!endDateTime ? 'text-gray-500' : 'text-gray-800'}`}
                        min={(() => {
                          const date = new Date();
                          const year = date.getFullYear();
                          const month = String(date.getMonth() + 1).padStart(2, '0');
                          const day = String(date.getDate()).padStart(2, '0');
                          const hours = String(date.getHours()).padStart(2, '0');
                          const minutes = String(date.getMinutes()).padStart(2, '0');
                          return `${year}-${month}-${day}T${hours}:${minutes}`;
                        })()}
                        step="60"
                      />
                    </div>
                  </div>
                </div>
              )}
            </FormGroup>
          </FormControl>
        )}
        {/* Ad Status Switch and Buttons */}
        <div className="flex items-center justify-end w-full gap-4 mt-6">
          {(
            <div style={{ display: 'flex', alignItems: 'center', marginRight: 'auto' }}>
              <span className="mr-2 font-medium text-[15px]">Paused</span>
              <Switch
                checked={adStatus}
                onChange={e => setAdStatus(e.target.checked)}
                color="primary"
                inputProps={{ 'aria-label': 'ad status switch' }}
                sx={{
                  '& .MuiSwitch-switchBase.Mui-checked': {
                    color: '#6E65ED',
                  },
                  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                    backgroundColor: '#6E65ED',
                  },
                  '& .MuiSwitch-track': {
                    backgroundColor: '#D1C4E9',
                  },
                }}
              />
              <span className="text-[14px] text-gray-500 ml-1.5">Active</span>
            </div>
          )}
          {/* Buttons */}
          <MuiButton
            onClick={handleClose}
            className="mr-2"
            disabled={isAdSetDuplicating}
            style={{
              width: 83,
              height: 38,
              borderRadius: 8,
              borderWidth: 1,
              borderStyle: 'solid',
              borderColor: '#00000026',
              gap: 10,
              opacity: 1,
              paddingTop: 8,
              paddingRight: 16,
              paddingBottom: 8,
              paddingLeft: 16,
              boxSizing: 'border-box',
              minWidth: 0,
              background: '#fff',
              color: '#1F2937',
              fontWeight: 500,
              fontSize: 16,
              lineHeight: '22px',
              textTransform: 'none',
              letterSpacing: 0,
              outline: 'none',
              boxShadow: 'none',
            }}
          >
            <span
              style={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 500,
                fontStyle: 'normal',
                fontSize: 16,
                lineHeight: '140%',
                letterSpacing: '-0.03em',
                textAlign: 'center',
                display: 'block',
              }}
            >
              Cancel
            </span>
          </MuiButton>
          <MuiButton
            variant="contained"
            color="primary"
            onClick={handleSaveAdSetDuplicate}
            disabled={
              isAdSetDuplicating ||
              !selectedAdSetForDuplicate ||
              !duplicateAdSetName?.trim() ||
              (
                selectedCampaign?.budgetType === "ABO" &&
                (
                  !adSetBudget?.trim() ||
                  isNaN(Number(adSetBudget)) ||
                  Number(adSetBudget) <= 0
                )
              )
            }
            style={{
              width: 133,
              height: 38,
              borderRadius: 8,
              gap: 10,
              opacity: 1,
              paddingTop: 8,
              paddingRight: 16,
              paddingBottom: 8,
              paddingLeft: 16,
              background: (
                isAdSetDuplicating ||
                !selectedAdSetForDuplicate ||
                !duplicateAdSetName?.trim() ||
                (
                  selectedCampaign?.budgetType === "ABO" &&
                  (
                    !adSetBudget?.trim() ||
                    isNaN(Number(adSetBudget)) ||
                    Number(adSetBudget) <= 0
                  )
                )
              ) ? '#DDD6FE' : '#6E65ED',
              minWidth: 0,
              fontWeight: 500,
              fontSize: 16,
              lineHeight: '22px',
              textTransform: 'none',
              letterSpacing: 0,
              outline: 'none',
              boxShadow: 'none',
              color: '#FFFFFF',
            }}
          >
            <span
              style={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 500,
                fontStyle: 'normal',
                fontSize: 16,
                lineHeight: '140%',
                letterSpacing: '-0.03em',
                textAlign: 'center',
                color: '#FFFFFF',
                display: 'block',
              }}
            >
              {isAdSetDuplicating ? "Duplicating..." : "Create Ad Set"}
            </span>
          </MuiButton>
        </div>
      </Box>
    </Modal>
  );
};

export default DuplicateAdsetModal;
